module.exports = __webpack_public_path__ + "img/EnracineConceptArt1_2141x2500.df4e882a.png";